import { createSelector } from 'reselect';
import { get } from 'lodash';
import { selectedCustomerIdSelector } from '../../common/selectors';
import requestStore from '../request/selectors';
import configSelector from '../config/selectors';
import uiSelector from '../ui/selectors';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const sharingSelector = createSelector(
  [requestStore, configSelector, uiSelector, selectedCustomerIdSelector],
  (request, configStore, uiStore, selectedCustomerId) => {
    const dashboard = 'timeline';
    const [start, end] = get(request, ['timelineInterval'], '0/0').split('/');
    const title = `${dashboard} ${start} ${end}`;
    return {
      title,
      start,
      end,
      dashboard,
      state: {
        request,
        configStore,
        uiStore,
        common: { selectedCustomerId },
      },
    };
  },
);

export const sharingResponseSelector = createSelector(selector, (store) => {
  const { response } = store;
  if (!response) {
    return null;
  }

  return JSON.parse(response.state);
});
